<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Konfigurator'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-commission-update-package-view *ngIf="!modify" [commissionUpdatePackage]="commissionUpdatePackage" (modifyClicked)="modify = true"></app-commission-update-package-view>
    <app-commission-update-package-add *ngIf="modify" [commissionUpdatePackageObject]="commissionUpdatePackageObject" (closeModification)="modify = false; load()" ></app-commission-update-package-add>
  </mat-tab>
  <mat-tab label="Polisy">
    <ng-template matTabContent>
      <app-all-commissions-list
        [embeddedView]="true"  [commissionUpdatePackageId]="commissionUpdatePackageObject.id"
        [enableFilters]="[
          'billingMonth', 'policyNumber', 'ofwca', 'collection',
          'partnerAssetsRegional', 'ofwcaAssetsRegional', 'notMatched', 'matched', 'contract',
          'createdAt', 'risk', 'status',
        ]"
      ></app-all-commissions-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [commissionUpdatePackage]="commissionUpdatePackage"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
